import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import ecom from "../../assets/ecom.svg";

import tyrion1 from "../../assets/tyrion1.svg";
import cart from "../../assets/cart-btn.svg";

import ty from "../../assets/ty.svg";

import InfoStepper from "../../components/InfoStepper";
import products from "../../data/ProductData";

function Ecomm() {
  const sweatshirtItems = products.filter(
    (item) => item.category === "sweatshirt"
  );
  const hoodieItems = products.filter((item) => item.category === "hoodie");
  const capItems = products.filter((item) => item.category === "cap");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mx-[28px] md:mx-[81px]">
      {/* section 1 */}
      <div className="flex justify-between mt-[28px] md:mt-[72px]  bg-[#F8F8F8] md:gap:[78px] md:mb-[80px] mb-[20px] pl-[24px] md:pl-[70px] pt-[48px] rounded-lg pr-[32px] ">
        <div className="container mx-auto">
          <h1 className="font-bold text-lg md:text-7xl mb-[20px]">
            Want to rock the <br />
            <span className="text-[#FBC108]">tyrion </span>
            branded
            <br /> product
          </h1>
          <p className="md:mb-[28px] mb-[15px] text-xs md:text-2xl opacity-[0.6]">
            Check out our cool
            <br className="md:hidden" /> merches
          </p>
          <button className="md:w-[210px] w-[90px] h-[26px] md:h-[70px] bg-[#000000] opacity-[0.8] text-xs md:text-base text-white rounded-lg">
            Shop now
          </button>
        </div>
        <img
          src={ecom}
          alt=""
          className="w-[150px] md:w-[384px] md:h-[461px] h-[223px] "
        />
      </div>
      {/* hoodies */}
      <div className="flex flex-col items-center  justify-center  underline mb-[5.75rem]  ">
        <h1 className="mb-[2rem] text-[3rem] font-medium">Tyrion Hoodies</h1>
        <div className="flex items-center justify-center gap-[1.12rem] ">
          {hoodieItems.map((item) => (
            <Link to={`/products/${item.id}`}>
              <div className="flex gap-[1.13rem] ">
                <div className="relative rounded-b-[0.5rem]">
                  <img src={item.image} alt="" className="rounded-b-[0.5rem]" />
                  <div className="absolute bottom-0 bg-[#FDFCF2] rounded-[0.5rem] w-full flex items-center flex-col py-[1.12rem] ">
                    <h6 className="text-[1.5rem] font-medium ">{item.name}</h6>
                    <p className="text-[#FBC108DC] ">{item.price}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* face caps */}
      <div className="flex flex-col items-center  justify-center  mb-[5.75rem]  ">
        <h1 className="mb-[2rem] underline text-[3rem] font-medium">
          Face Caps
        </h1>
        <div className="flex justify-center gap-[3.31rem]">
          {capItems.map((item) => (
            <Link to={`/products/${item.id}`}>
              <div className={`flex flex-col p-[0.12rem] bg-[#FDFCF2]`}>
                <img
                  src={item.image}
                  alt={""}
                  className="self-center md:mb-[10px]"
                />
                <div className="flex justify-items-end flex-col ">
                  <h5 className="self-center text-[6px] md:text-base font-medium md:mb-[10px]">
                    {item.name}
                  </h5>
                  <h5 className="self-center text-[#FFC700] text-[6px] md:text-base">
                    {item.price}
                  </h5>
                  <button className="self-end mt-[10px]">
                    <img
                      src={cart}
                      alt="Cart"
                      className="w-[11px] md:w-[44px] drop-shadow-2xl"
                    />
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* sweatshirt */}

      <div className="flex flex-col items-center  justify-center  mb-[5.75rem]  ">
        <h1 className="mb-[2rem] underline text-[3rem] font-medium">
          Sweatshirts
        </h1>
        <div className="flex justify-center gap-[3.31rem]">
          {sweatshirtItems.map((item) => (
            <Link to={`/products/${item.id}`}>
              <div
                className={`flex flex-col p-[0.12rem] bg-[#FDFCF2]`}
                key={item.id}
              >
                <img
                  src={item.image}
                  alt={""}
                  className="self-center md:mb-[10px]"
                />
                <div className="flex justify-items-end flex-col ">
                  <h5 className="self-center text-[6px] md:text-base font-medium md:mb-[10px]">
                    {item.name}
                  </h5>
                  <h5 className="self-center text-[#FFC700] text-[6px] md:text-base">
                    {item.price}
                  </h5>

                  <button className="self-end mt-[10px]">
                    <img
                      src={cart}
                      alt="Cart"
                      className="w-[11px] md:w-[44px] drop-shadow-2xl"
                    />
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* trending products */}
      <div className="md:w-[70.7rem] w-[326px] mb-[98px] md:mb-[179px] md:pt-[79px] pt-[19px] pl-[26px] md:pl-[104px] bg-[#1E1E1E] justify-between text-white rounded-lg flex mx-auto ">
        <div className="flex gap-[7px] md:gap-[25px] flex-col">
          <h1 className="font-bold md:text-6xl">
            <span className="text-[#FBC10886]">Trending</span>
            <br />
            Products
          </h1>
          <p className="text-[#E7E7E7] md:text-xl text-[5px]">
            What do you stand for? We have a <br /> product for every version
            you are.
          </p>
          <button className="md:w-[201px] w-[50px] h-[17px] md:h-[70px] bg-[#fcb108] rounded-lg md:text-base text-[5px]">
            Shop now
          </button>
        </div>
        <img
          src={tyrion1}
          alt=""
          className="w-[100px] md:w-[401px] md:h-full h-[142px] "
        />
      </div>

      {/* section 5 */}
      <h1 className="text-3xl font-medium ">Connect your wallet</h1>
      <div className="md:mb-[50px] flex flex-col md:flex-row md:justify-between md:items-start w-full ">
        <div className=" text-justify ">
          <InfoStepper cardOn={"shop1"} />
        </div>
        <div className="md:w-full flex justify-end  mb-[-8.55%] w-auto mx-auto ">
          <img src={ty} alt="" className="md:w-[429px] md:h-[600px] " />
        </div>
      </div>
    </div>
  );
}

export default Ecomm;
